import React from 'react'
import './investors.css'

export class Intro extends React.Component {

    render() {
        return (
            <div className='intro'>
                <h1>Join Norway's Next AI Success Story</h1>
                <p>tigercity.ai is an AI startup based in Oslo, Norway, solving the fundamental problem that's holding back the AI revolution.</p>
            </div>
        );
    }
}

